// src/components/layout/Footer.jsx
import { useNavigate } from 'react-router-dom';
import { C } from '../../styles/tokens';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer style={{ background: C.surface1, borderTop: '1px solid rgba(254,52,232,0.08)', padding: '52px clamp(16px,4vw,28px) 28px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: '40px', marginBottom: '40px' }}>
          {/* Brand */}
          <div style={{ gridColumn: 'span 2' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '14px', cursor: 'pointer' }} onClick={() => navigate('/')}>
              <div style={{ width: '30px', height: '30px', borderRadius: '7px', background: `linear-gradient(135deg,${C.magenta},${C.violet})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px' }}>⬡</div>
              <span style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: '15px' }}>Oracle <span style={{ color: C.magenta }}>Nexus</span></span>
            </div>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.35)', lineHeight: 1.8, maxWidth: '260px' }}>
              Next-generation talent platform powered by AI, blockchain, and human ambition.
            </p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
              {['𝕏', 'in', '📱'].map(s => (
                <div key={s} style={{ width: '34px', height: '34px', borderRadius: '7px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.09)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', cursor: 'pointer' }}>{s}</div>
              ))}
            </div>
          </div>
          {/* Links */}
          {[
            { title: 'Platform', links: [['Opportunities', '/opportunities'], ['AI CV Optimizer', '/cv-optimizer'], ['ONT Wallet', '/wallet'], ['Training Hub', '/training'], ['Referrals', '/referral']] },
            { title: 'Company',  links: [['About Us', '/about'], ['Blog', '/blog'], ['Careers', '/careers'], ['Press', '/press'], ['Contact', '/contact']] },
            { title: 'Legal',    links: [['Privacy Policy', '/privacy'], ['Terms of Service', '/terms'], ['Disclaimer', '/disclaimer'], ['GDPR', '/gdpr']] },
          ].map(col => (
            <div key={col.title}>
              <h4 style={{ fontFamily: "'Syne',sans-serif", fontSize: '12px', fontWeight: 700, color: 'rgba(255,255,255,0.45)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '14px' }}>{col.title}</h4>
              {col.links.map(([label, path]) => (
                <div key={label} onClick={() => navigate(path)} style={{ fontSize: '13px', color: 'rgba(255,255,255,0.36)', marginBottom: '9px', cursor: 'pointer', transition: 'color 0.2s' }} onMouseEnter={e => e.target.style.color = 'rgba(255,255,255,0.7)'} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.36)'}>{label}</div>
              ))}
            </div>
          ))}
        </div>
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.22)' }}>© 2025 Oracle Nexus. All rights reserved.</span>
          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.22)' }}>Built on Solana · Secured by Firebase · Powered by AI</span>
        </div>
      </div>
    </footer>
  );
}
